import React from 'react';
import styles from './LiveLocationBanner.module.css';

export const LiveLocationBanner: React.FC = () => {
  return (
    <div className={styles.banner}>
      <div className={styles.left}>
        <div className={styles.iconCircle}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
          </svg>
        </div>
        <div className={styles.textWrap}>
          <div className={styles.titleRow}>
            <span className={styles.title}>Live Location Tracking Active</span>
            <span className={styles.alwaysOn}>Always On</span>
          </div>
          <p className={styles.subtitle}>
            Your manager can track your location and route progress in real-time
          </p>
        </div>
      </div>
      <div className={styles.broadcasting}>
        <span className={styles.broadcastDot} />
        Broadcasting
      </div>
    </div>
  );
};
